import React from 'react';
import { Row, Col } from 'antd';
import { GeneralInformationSummary } from '../GeneralInformationSummary';
import { ToolsSection } from './ToolsSection';
import { Footer } from './Footer';

export function Tools() {
	return (
		<Row gutter={[0, 40]}>
			<Col span={24}>
				<GeneralInformationSummary />
			</Col>
			<Col span={24}>
				<ToolsSection />
			</Col>
			<Col span={24}>
				<Footer />
			</Col>
		</Row>
	);
}
